export const isUndefined = subject => {
  return typeof subject === 'undefined'
}

export const isCustomTime = time => {
  return /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(time)
}
